import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";

export function RefundControl({ jobId, onRefunded }) {
  const [data, setData] = useState(null);
  const [amt, setAmt] = useState({});
  const [reason, setReason] = useState({});
  const [busy, setBusy] = useState("");

  const load = async () => {
    try { const { data } = await api.get(`/jobs/${jobId}/payments`); setData(data); }
    catch { setData({ payments: [], refunds: [] }); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const refund = async (p) => {
    if (!reason[p.id]?.trim()) { toast.error("A refund reason is required"); return; }
    const a = Number(amt[p.id] || p.refundable);
    if (a <= 0 || a > p.refundable) { toast.error(`Enter an amount between $1 and $${p.refundable}`); return; }
    setBusy(p.id);
    try {
      const { data: r } = await api.post(`/payments/${p.id}/refund`, { amount: a, reason: reason[p.id] });
      toast.success(`Refund ${r.status || "submitted"} — $${r.amount} (job now ${r.payment_state})`);
      await load(); onRefunded?.(r);
    } catch (e) { toast.error(e.response?.data?.detail || "Refund failed"); }
    finally { setBusy(""); }
  };

  if (!data || !data.payments.length) return null;
  return (
    <div className="sg-card-elev p-4 mt-3" data-testid="refund-control">
      <div className="font-head font-bold mb-2 flex items-center gap-2"><RotateCcw size={16} style={{ color: "var(--accent)" }} /> Refunds (Owner/Manager)</div>
      {data.payments.map((p) => (
        <div key={p.id} className="text-sm py-2" style={{ borderTop: "1px solid var(--brd)" }} data-testid={`refund-payment-${p.id}`}>
          <div style={{ color: "var(--txt2)" }}>{p.kind} · ${p.amount} · {p.status}{p.refunded_amount ? ` · refunded $${p.refunded_amount}` : ""} · refundable <b style={{ color: "var(--txt)" }}>${p.refundable}</b></div>
          {p.refundable > 0 && (
            <div className="flex flex-wrap gap-2 mt-2 items-center">
              <input type="number" min="1" placeholder={`$${p.refundable}`} value={amt[p.id] || ""} onChange={(e) => setAmt({ ...amt, [p.id]: e.target.value })} className="sg-input" style={{ maxWidth: 100, padding: "6px 8px" }} data-testid={`refund-amount-${p.id}`} />
              <input placeholder="Reason (required)" value={reason[p.id] || ""} onChange={(e) => setReason({ ...reason, [p.id]: e.target.value })} className="sg-input flex-1" style={{ padding: "6px 8px", minWidth: 160 }} data-testid={`refund-reason-${p.id}`} />
              <button className="sg-btn" style={{ minHeight: 36 }} disabled={busy === p.id} onClick={() => refund(p)} data-testid={`refund-btn-${p.id}`}>{busy === p.id ? "…" : "Refund"}</button>
            </div>
          )}
        </div>
      ))}
      {data.refunds?.length > 0 && (
        <div className="text-[11px] mt-2" style={{ color: "var(--muted)" }} data-testid="refund-history">
          {data.refunds.length} refund record(s) · latest {data.refunds[0].status} ${data.refunds[0].amount}
        </div>
      )}
    </div>
  );
}
